module.exports = __webpack_public_path__ + "img/4-1.cd2ccc5e.png";